/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ArchivePaymentLinkInput } from '../models/ArchivePaymentLinkInput';
import type { BuildPaymentLinkInput } from '../models/BuildPaymentLinkInput';
import type { EnrichedPaymentLink } from '../models/EnrichedPaymentLink';
import type { PaymentLinkCreateDTO } from '../models/PaymentLinkCreateDTO';
import type { PaymentLinkOut } from '../models/PaymentLinkOut';
import type { PaymentLinkPaymentStatus } from '../models/PaymentLinkPaymentStatus';
import type { PaymentLinkResponseDTO } from '../models/PaymentLinkResponseDTO';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PaymentLinkService {
  /**
   * Create Payment Link
   * @param requestBody
   * @returns PaymentLinkOut Successful Response
   * @throws ApiError
   */
  public static createPaymentLink(requestBody: PaymentLinkCreateDTO): CancelablePromise<PaymentLinkOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/payment_link',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Payment Links Paginated
   * @param page Page number
   * @param perPage Items per page
   * @param search Search value
   * @param statuses List of statuses
   * @param withPastOrders
   * @param withArchivedPaymentLinks
   * @returns EnrichedPaymentLink Successful Response
   * @throws ApiError
   */
  public static getPaymentLinks(
    page: number = 1,
    perPage: number = 10,
    search?: string,
    statuses?: Array<PaymentLinkPaymentStatus>,
    withPastOrders: boolean = false,
    withArchivedPaymentLinks: boolean = false,
  ): CancelablePromise<Array<EnrichedPaymentLink>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment_link',
      query: {
        page: page,
        per_page: perPage,
        search: search,
        statuses: statuses,
        with_past_orders: withPastOrders,
        with_archived_payment_links: withArchivedPaymentLinks,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Payment Links
   * @param orderId
   * @returns PaymentLinkOut Successful Response
   * @throws ApiError
   */
  public static getPaymentLinkByOrderId(orderId: string): CancelablePromise<Array<PaymentLinkOut>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/payment_link/get_by_order',
      query: {
        order_id: orderId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Payment Link
   * @param requestBody
   * @returns PaymentLinkResponseDTO Successful Response
   * @throws ApiError
   */
  public static buildPaymentLink(requestBody: BuildPaymentLinkInput): CancelablePromise<PaymentLinkResponseDTO> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/build_payment_link',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Archive Payment Link
   * @param requestBody
   * @returns PaymentLinkOut Successful Response
   * @throws ApiError
   */
  public static archivePaymentLink(requestBody: ArchivePaymentLinkInput): CancelablePromise<PaymentLinkOut> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/payment_link/archive',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
